var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardProgram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30859 16.0332H12.4437V26.4423H4.22605C3.17419 26.4423 2.30859 25.5767 2.30859 24.5248V16.0332Z",
    fill: "url(#paint0_linear_740_6175)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2211 16.0332V24.5248C24.2211 25.5767 23.3555 26.4423 22.3036 26.4423H14.0859V16.0332H24.2211Z",
    fill: "url(#paint1_linear_740_6175)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.109375 9.73191V12.4711C0.109375 13.523 0.974971 14.3886 2.02683 14.3886H2.30076H12.4359V12.7451V7.81445H2.02683C0.974971 7.81445 0.109375 8.68005 0.109375 9.73191Z",
    fill: "url(#paint2_linear_740_6175)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.495 7.81445H14.0859V12.7451V14.3886H24.2211H24.495C25.5469 14.3886 26.4125 13.523 26.4125 12.4711V9.73191C26.4125 8.68005 25.5469 7.81445 24.495 7.81445Z",
    fill: "url(#paint3_linear_740_6175)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.259 8.95875C13.0201 8.95875 12.7922 8.85466 12.6377 8.67387C12.481 8.49308 12.412 8.25313 12.446 8.01646C12.8514 5.27723 14.9913 0.0957031 20.1936 0.0957031C23.1629 0.0967988 24.2159 1.70089 24.2159 3.07489C24.2159 5.51719 20.816 8.95875 13.259 8.95875ZM20.1936 1.74034C16.2688 1.74034 14.7787 5.47117 14.2845 7.29111C17.381 7.14648 19.3335 6.36306 20.4577 5.69578C22.0168 4.76992 22.5724 3.73449 22.5724 3.07379C22.5724 2.08986 21.3441 1.74034 20.1936 1.74034Z",
    fill: "url(#paint4_linear_740_6175)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2655 8.95765C5.70852 8.95765 2.30859 5.51609 2.30859 3.07379C2.30859 1.6998 3.36265 0.0957031 6.33197 0.0957031C11.5332 0.0957031 13.6731 5.27723 14.0785 8.01646C14.1125 8.25313 14.0434 8.49308 13.8868 8.67387C13.7323 8.85357 13.5044 8.95765 13.2655 8.95765ZM6.33197 1.73924C5.1815 1.73924 3.95213 2.08986 3.95213 3.07379C3.95213 4.47299 6.39881 7.02266 12.2388 7.29111C11.7458 5.47007 10.2556 1.73924 6.33197 1.73924Z",
    fill: "url(#paint5_linear_740_6175)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_6175",
    x1: 4.65354,
    y1: 21.9184,
    x2: 12.3709,
    y2: 21.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_6175",
    x1: 16.4309,
    y1: 21.9184,
    x2: 24.1483,
    y2: 21.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_6175",
    x1: 2.96134,
    y1: 11.5314,
    x2: 12.3473,
    y2: 11.5272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_740_6175",
    x1: 16.9379,
    y1: 11.5314,
    x2: 26.3239,
    y2: 11.5272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_740_6175",
    x1: 15.1626,
    y1: 5.10678,
    x2: 24.1312,
    y2: 5.10392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_740_6175",
    x1: 5.03374,
    y1: 5.10616,
    x2: 14.0023,
    y2: 5.1033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardProgram);
export default __webpack_public_path__ + "static/media/reward-program.f7b6ffd5b8cff8b949ef3231a4e0e5ec.svg";
export { ForwardRef as ReactComponent };